import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { useNavigation } from "../../../hooks/useNavigation";
import { validatePhoneNumber } from "../../../utils/validation";

export const usePhoneNumberSetting = () => {
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();
  const { token, password, isRegistration } = state ?? {};

  useEffect(() => {
    if (!token || !password) navigateToPage(PageRoutes.LOGIN);
  }, [token, password]);

  const handlePhoneNumberSetting = useCallback(
    (phoneNumber: string, onError: () => void) => {
      if (!validatePhoneNumber(phoneNumber)) return onError();

      navigateToPage(PageRoutes.SMS_SEND, false, {
        password,
        phoneNumber,
        token,
        isActivation: true,
        isRegistration,
      });
    },
    [],
  );

  return { handlePhoneNumberSetting };
};
